import { Link } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'

import { trackgoodIcon } from 'src/assets/icons'

import useStyles from './styles'
import { useAccount } from 'src/hooks'

const defaultQRCodeValue = 'No link has been provided for the QRCode on this page'

interface IQRCodeImageProps {
  qrLink?: string
  size?: string
}

const QRCode = ({ qrLink, size }: IQRCodeImageProps) => {
  const classes = useStyles({ size })

  const { data: account } = useAccount()

  const imageSRC =
    account && account?.white_label?.qr_code_logo
      ? account.white_label?.qr_code_logo
      : trackgoodIcon

  return (
    <Link href={qrLink} target="__blank" rel="noopener noreferrer">
      <QRCodeSVG
        className={classes.qrCodeImage}
        value={qrLink ? qrLink : defaultQRCodeValue}
        imageSettings={{
          src: imageSRC,
          height: 22,
          width: 22,
          excavate: true,
        }}
      />
    </Link>
  )
}

export { QRCode }
